module.exports = __webpack_public_path__ + "img/borderWavesBlue.df9f10e0.png";